export default {
	data() {
		return {
			errorDetails: false,
			productsDocument: [],
		}
	},
	mounted() {
		this.setRules();
	},
	computed: {
		productsAvailables() {
			let availables = [];
			for (const product of this.productsDocument) {
				let omit = false;
				for (const detail of this.form.details) {
					if (product.id == detail.product.id && detail._editing == false) {
						omit = true;
					}
				}
				if (omit == false) {
					availables.push(product);
				}
			}
			return availables;
		}
	},
	methods: {
		reset() {
			this.form = { details: [] }; //The details should be initialized as an empty array.
		},
		disabledUpdate() {
			if (this.disabledCreate()) {
				return true;
			}
			return false;
		},
		resetDetails() {
			this.form.details = [];
		},
		allowUpdate() {
			if (this.item) {
				if (this.item.document_state && this.item.document_state.id == "draft") {
					return true;
				} else {
					return false;
				}
			}
			return true;
		},
		executeInProgress() {
			this.changeState('in_progress');
		},
		executeAnnulled() {
			this.changeState('annulled', 'enter_cancellation_reason', this.openDialogText);
		},
		executeFinalized() {
			this.changeState('finalized', 'want_approve_document', this.openConfirm);
		},
		executeDraft() {
			this.changeState('draft');
		},
		changeState(status, text = null, typeModal = this.openDialogText) {
			typeModal(
				this.$t(text)
			).then((response) => {
				if (response) {
					// console.log("change", this.urlSave, this.item.id);
					this.$http
						.post(
							this.urlSave + "/" + this.item.id + "/change-status",
							{ status, note: response },
							true,
							true
						)
						.then((response) => {
							if (response.success) {
								this.$nextTick(() => {
									this.item.document_state = response.item.document_state;
									this.item._actions = response.item._actions;
								});
							}
						});
				}
			});
		},

	}
}
